import { CSSObject, styled, SxProps } from '@mui/material';

export const DatagridSx: SxProps = {
  '& .MuiTableRow-root.RaDatagrid-expandedPanel:hover, & .MuiTableRow-root.RaDatagrid-expandedPanel': {
    backgroundColor: 'transparent !important',
  },
  '& .RaDatagrid-expandedPanel .MuiTableCell-root': {
    backgroundColor: 'transparent !important',
  },
};

export const GridRowSx: SxProps = {
  mx: -1,
  px: 1,
  py: 0.5,
  borderRadius: 1,
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: 'rgba(125, 173, 255, 0.1)',
  },
};

export const ReportNameContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
});
